import styled, {css} from "styled-components";

export const InputWrap = styled.div`
    width: 100%;
    position: relative;
    label {
        width: 100%;
        padding: 0;
        font-size: 16px;
        font-weight: 500;
        line-height: 120%;
        color: var(--matte-black);
        z-index: 5;
        display: flex;
        margin-bottom: 10px;
        @media screen and (min-width: 1441px) {
            font-size: 18px;
        }
    }
`;

export const StyledTexfield = styled.div`
    padding: 14px;
    border-radius: ${({$variant}) => ($variant == "input" ? "60px" : "20px")};
    /* outline: none !important; */
    /* outline: ${({$noOutline}) => ($noOutline ? "none" : "")}; */
    background: transparent;
    /* box-shadow: rgba(0, 0, 0, 0.09) 0 0 2px 1px; */
    color: rgba(49, 49, 49, 1) !important;
    position: relative;
    box-sizing: border-box;
    width: 100%;
    font-size: 16px;
    font-weight: 500 !important;
    margin-bottom: ${({$noMargin}) => ($noMargin ? "0" : "15px")};
    &::placeholder {
        color: #898989;
    }
    &:focus {
        border: 1px solid var(--primary);
    }
    ${({$hasicon}) =>
        $hasicon &&
        css`
            padding: 12px 50px;
        `}
`;

export const IconWrapper = styled.span`
    position: absolute;
    top: 12px;
    left: 20px;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    img {
        max-width: 100%;
        height: auto;
    }
`;
export const StyledInput = styled.input`
    border: none;
    outline: none;
    background: transparent;
    color: var(--matte-black);
    width: 100%;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
    font-family: inherit;
    &::placeholder {
        color: var(--body-text-25);
    }
    @media (min-width: 576px) {
        font-size: 16px;
    }
`;
